<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import groupBy from "lodash/groupBy";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { required } from "vuelidate/lib/validators";
import MaskedInput from "vue-text-mask";
import PrintOptions from "@/components/modals/print-options.vue";
import PlanningRatingScale from "@/components/modals/planning-rating-scale.vue";
import KpiTags from "@/components/modals/kpi-tags.vue";
import Multiselect from "vue-multiselect";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Planning Targets/Delivarables",
  },
  components: {
    Layout,
    PageHeader,
    MaskedInput,
    PrintOptions,
    PlanningRatingScale,
    KpiTags,
    Multiselect,
    RawData
  },
  data() {
    return {
      title: `My Planning ${this.$store.state.data.selectedCampus.isExternal
          ? "Deliverables"
          : "Targets"
        }`,
      titleList: this.$store.state.data.selectedCampus.isExternal
        ? "Deliverable"
        : "Target",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: `My Planning ${this.$store.state.data.selectedCampus.isExternal
              ? "Deliverables"
              : "Targets"
            }`,
          active: true,
        },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      modalTitle: "",
      filter: "",
      sortBy: "cluster",
      sortDesc: false,
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
        includeThousandsSeparator: false,
      }),
      ppFields: [
        {
          key: "displayDetails",
          sortable: false,
          label: " ",
          thStyle: { width: "30px" },
        },
        // {
        //   key: "planningMainTarget.indicatorItem.indicatorItemName",
        //   sortable: true,
        //   label: "KPI",
        //   thStyle: { width: "20%" },
        // },
        {
          key: "description",
          sortable: true,
          label: "Target Description",
        },
        {
          key: "q1",
          label: "Quarter 1",
          thStyle: { width: "150px" },
        },
        {
          key: "q2",
          label: "Quarter 2",
          thStyle: { width: "150px" },
        },
        {
          key: "q3",
          label: "Quarter 3",
          thStyle: { width: "150px" },
        },
        {
          key: "q4",
          label: "Quarter 4",
          thStyle: { width: "150px" },
        },
        {
          key: "actions",
          thStyle: { width: "100px" },
        },
      ],
      pp: {
        id: 0,
        planningMainTargetId: 0,
        q1: 0,
        q1Text: "",
        q2: 0,
        q2Text: "",
        q3: 0,
        q3Text: "",
        q4: 0,
        q4Text: "",
        points: 0,
        deliveryUnitId: 0,
        cascadedTarget: 0,
        cascadedTargetText: "",
      },
      tableData: [],
      tableBusy: false,
      selectedTargetData: null,
      rating: {
        r1: null,
        r2: null,
        r3: null,
        r4: null,
        r5: null,
        method: null,
      },
      ratingBusy: false,
      isOPCRPosted: false,
      tabSelect: "Strategic Priority",
      tabOptions: [
        "Strategic Priority",
        "Core Functions",
        "Mandatory Support Function",
      ],
      isPercentage: false,
      tabIndex: 0,
      selectedTarget: null,
      allDepartments: []
    };
  },
  validations: {
    pp: {
      description: { required },
    },
    rating: {
      r1: { required },
      r2: { required },
      r3: { required },
      r4: { required },
      r5: { required },
      method: { required },
    },
  },
  computed: {
    grouped() {
      var array = [];
      var x = groupBy(this.filteredData, "planningMainTarget.indicatorItemId");
      for (const key in x) {
        array.push({
          indicatorItemId: key,
          indicatorItemName:
            x[key][0].planningMainTarget.indicatorItem.indicatorItemName,
          details: x[key],
          showTargets: false,
          targetLoading: false,
        });
      }
      return array;
    },
    filteredData() {
      let data = this.tableData;
      data = data.filter((item) => {
        if (this.tabSelect == "Strategic Priority")
          return item.planningMainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("STRATEGIC");
        else if (this.tabSelect == "Core Functions")
          return item.planningMainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("CORE");
        else if (this.tabSelect == "Mandatory Support Function")
          return item.planningMainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("MANDATORY");
        else return item;
      });
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.searchKey
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    paginatedData() {
      let data = this.grouped;
      var total = this.currentPage * this.perPage;
      data = data.slice(total - this.perPage, total);
      return data;
    },
    rows() {
      return this.grouped.length;
    },
  },
  created() {
    this.totalRows = this.tableData.length;
    this.changeCycle(this.$store.state.data.cycle);
    this.getAllDepartments(this.$store.state.data.selectedDU.id);
  },
  methods: {
    changeCycle(cycle) {
      this.getMyPreplanTargets(cycle, this.$store.state.data.selectedDU.id);
    },
    changeDU(du) {
      (this.title = `My Planning ${du.isExternal ? "Deliverables" : "Targets"
        }`),
        (this.items = [
          {
            text: "Dashboards",
            href: "/",
          },
          {
            text: `My Planning ${du.isExternal ? "Deliverables" : "Targets"}`,
            active: true,
          },
        ]),
        this.getMyPreplanTargets(this.$store.state.data.cycle, du.id);
      this.getAllDepartments(du.id);
    },
    checkTab(type) {
      let data = this.tableData;
      data = data.filter((item) => {
        if (type == "Strategic Priority")
          return item.planningMainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("STRATEGIC");
        else if (type == "Core Functions")
          return item.planningMainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("CORE");
        else if (type == "Mandatory Support Function")
          return item.planningMainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("MANDATORY");
        else if (this.tabSelect == "Intervening Task")
          return item.planningMainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("INTERVENING");
      });
      return data.length > 0 ? true : false;
    },
    setTabSelect() {
      this.tabSelect = this.checkTab("Strategic Priority")
        ? "Strategic Priority"
        : this.checkTab("Core Functions")
          ? "Core Functions"
          : this.checkTab("Mandatory Support Function")
            ? "Mandatory Support Function"
            : "Intervening Task";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    checkPostedOPCR(cycle, deliveryUnitId) {
      this.$store
        .dispatch("preopcr/GetAllPreOpcr", {
          cycle,
          deliveryUnitId,
        })
        .then((res) => {
          if (res.data.length > 0) {
            this.isOPCRPosted = true;
            for (let count = 0; count < res.data.length; count++) {
              if (
                res.data[count].status == "DRAFT" ||
                res.data[count].status == "RETURNED"
              ) {
                this.isOPCRPosted = false;
              }
            }
          } else {
            this.isOPCRPosted = false;
          }
        });
    },
    getMyPreplanTargets(cycle, deliveryUnitId) {
      this.tableBusy = true;
      this.checkPostedOPCR(cycle, deliveryUnitId);
      this.$store
        .dispatch("planningtarget/GetPostedPlanningTargetByDU", {
          cycle,
          deliveryUnitId,
        })
        .then((res) => {
          this.tableBusy = false;
          res.data.forEach((item) => {
            item.showDetails = false;
            item.rotateChevy = false;
            item.searchKey =
              item.planningMainTarget.indicatorItem.indicatorItemName +
              " " +
              item.description;
            item.attachments = [];
            item.tags = [];
            item.departmentList = [];
            item.assignedDepartments = [];
            item.departmentModels = [];
            item.editAssDeps = false;
          });
          this.tableData = res.data;
          this.setTabSelect();
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast("Something went wrong!", "error");
        });
    },
    onResetPP() {
      this.pp = {
        id: 0,
        planningMainTargetId: 0,
        q1: "0",
        q1Text: "",
        q2: "0",
        q2Text: "",
        q3: "0",
        q3Text: "",
        q4: "0",
        q4Text: "",
        points: "0",
        cascadedTarget: "0",
        cascadedTargetText: "",
        deliveryUnitId: 0,
      };
      this.$v.pp.$reset();
    },
    addTarget(row) {
      this.onResetPP();
      this.selectedTargetData = cloneDeep(row);
      this.pp.planningMainTargetId = cloneDeep(row.planningMainTargetId);
      this.pp.deliveryUnitId = cloneDeep(row.deliveryUnitId);
      this.pp.allowAdd = cloneDeep(row.planningMainTarget.allowAdd);
      this.pp.allowEdit = cloneDeep(row.allowEdit);
      this.pp.planningMainTarget = cloneDeep(row.planningMainTarget);
      this.modalTitle = "Add Target";
      this.$bvModal.show("update-target-modal");
    },
    updateTarget(row) {
      this.selectedTargetData = cloneDeep(row);
      this.pp = {
        id: cloneDeep(row.id),
        planningMainTargetId: cloneDeep(row.planningMainTargetId),
        planningMainTarget: cloneDeep(row.planningMainTarget),
        deliveryUnitId: cloneDeep(row.deliveryUnitId),
        description: cloneDeep(row.description),
        q1: cloneDeep(row.q1.toString()),
        q1Text: cloneDeep(row.q1Text),
        q2: cloneDeep(row.q2.toString()),
        q2Text: cloneDeep(row.q2Text),
        q3: cloneDeep(row.q3.toString()),
        q3Text: cloneDeep(row.q3Text),
        q4: cloneDeep(row.q4.toString()),
        q4Text: cloneDeep(row.q4Text),
        cascadedTarget: cloneDeep(row.cascadedTarget.toString()),
        cascadedTargetText: cloneDeep(row.cascadedTargetText),
        points: cloneDeep(row.points.toString()),
        allowAdd: cloneDeep(row.planningMainTarget.allowAdd),
        allowEdit: cloneDeep(row.allowEdit),
      };
      this.modalTitle = "Update Target";
      this.$bvModal.show("update-target-modal");
    },
    async onAddTarget() {
      this.submitted = true;
      this.$v.pp.$touch();
      if (this.$v.pp.$invalid) {
        return;
      }
      if (this.selectedTargetData.planningMainTarget.indicatorItem.allowText) {
        if (!this.pp.q1Text || !this.pp.q2Text || !this.pp.q3Text || !this.pp.q4Text || !this.pp.cascadedTargetText) {
          return;
        }
      } else {
        if (
          !this.pp.q1 ||
          !this.pp.q2 ||
          !this.pp.q3 ||
          !this.pp.q4 ||
          !this.pp.cascadedTarget
        ) {
          return;
        }
      }
      if (this.pp.id > 0) {
        await this.$store
          .dispatch("planningtarget/UpdatePlanningTarget", this.pp)
          .then((res) => {
            let index = this.tableData.findIndex(
              (item) => item.id == this.pp.id
            );
            this.tableData[index].description = cloneDeep(this.pp.description);
            for (let x = 1; x <= 4; x++) {
              this.tableData[index][`q${x}Text`] = cloneDeep(this.pp[`q${x}Text`]);
              this.tableData[index][`q${x}`] = cloneDeep(this.pp[`q${x}`]);
            }
            this.tableData[index].points = cloneDeep(this.pp.points);
            this.tableData[index].cascadedTarget = cloneDeep(
              this.pp.cascadedTarget
            );
            this.tableData[index].planningMainTarget = cloneDeep(
              this.pp.planningMainTarget
            );
            this.$bvModal.hide("update-target-modal");
            this.showToast("Successfully updated!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        await this.$store
          .dispatch("planningtarget/CreatePlanningTarget", this.pp)
          .then((res) => {
            res.data.showDetails = false;
            res.data.rotateChevy = false;
            res.data.planningMainTarget = cloneDeep(this.pp.planningMainTarget);
            res.data.searchKey =
              res.data.planningMainTarget.indicatorItem.indicatorItemName +
              " " +
              res.data.description;
            res.data.attachments = [];
            res.data.tags = [];
            res.data.departmentList = [];
            res.data.assignedDepartments = [];
            res.data.departmentModels = [];
            res.data.editAssDeps = false;
            this.tableData.push(res.data);
            this.$bvModal.hide("update-target-modal");
            this.showToast("Successfully created!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
      this.submitted = false;
    },
    calculateAnnualTarget() {
      if (!this.selectedTargetData.planningMainTarget.isPercentage) {
        let total =
          parseFloat(this.pp.q1 ? this.pp.q1 : 0) +
          parseFloat(this.pp.q2 ? this.pp.q2 : 0) +
          parseFloat(this.pp.q3 ? this.pp.q3 : 0) +
          parseFloat(this.pp.q4 ? this.pp.q4 : 0);
        this.pp.cascadedTarget = total.toString();
      } else {
        let lastQuarter = 0;
        if (parseFloat(this.pp.q1 ? this.pp.q1 : 0) != 0)
          lastQuarter = parseFloat(this.pp.q1);
        if (parseFloat(this.pp.q2 ? this.pp.q2 : 0) != 0)
          lastQuarter = parseFloat(this.pp.q2);
        if (parseFloat(this.pp.q3 ? this.pp.q3 : 0) != 0)
          lastQuarter = parseFloat(this.pp.q3);
        if (parseFloat(this.pp.q4 ? this.pp.q4 : 0) != 0)
          lastQuarter = parseFloat(this.pp.q4);
        this.pp.cascadedTarget = lastQuarter.toString();
      }
    },
    changeFilter(type) {
      this.title = `My Targets (${type})`;
      // this.selectedTarget = type;
    },
    deletePPTarget(row) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
      }).then(async (result) => {
        if (result.value) {
          let index = this.tableData.findIndex((item) => item.id == row.id);
          await this.$store
            .dispatch("planningtarget/DeletePlanningTarget", row.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.tableData.splice(index, 1);
              this.showToast("Successfully deleted!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    setMeasurement(row) {
      this.$bvModal.show("performance-rating-modal");
      let access = this.isOPCRPosted ? "planning" : "du";
      this.$refs.PlanningRatingScale.setMeasurement(row, access);
    },
    printTPMS() {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/TPMS",
        routeVariables: [
          this.$store.state.data.cycle,
          this.$store.state.data.selectedDU.id,
        ],
      });
      this.$bvModal.show("print-options-modal");
    },
    addTags(target) {
      this.selectedTarget = target;
      this.$refs.kpiTags.resetTags(target.tags);
      this.$bvModal.show("kpi-tag-modal");
    },
    getTags(target) {
      target.tags = [];
      this.$store
        .dispatch("planningtarget/GetTagsByTarget", target.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          target.tags = res.data;
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    dropKpiTags($event) {
      let tags = $event.map((x) => x.id);
      this.$store
        .dispatch("planningtarget/AddTagByTarget", {
          planningTargetId: this.selectedTarget.id,
          tagIds: tags,
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.showToast("Successfully tagged!", "success");
          this.getTags(this.selectedTarget);
          this.$bvModal.hide("kpi-tag-modal");
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getTagsByTarget(x) {
      x.showTargets = !x.showTargets;
      this.$forceUpdate();
      if (x.showTargets) {
        x.targetLoading = true;
        for await (const item of x.details) {
          await this.getTags(item);
        }
        setTimeout(() => {
          x.targetLoading = false;
          this.$forceUpdate();
        }, 500);
      }
    },
    deleteTag(row, parent) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("planningtarget/RemoveTags", row.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = parent.tags.findIndex((x) => x.id == row.id);
              parent.tags.splice(index, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    async getDepartments(row) {
      row.departmentList = [];
      this.$store
        .dispatch("planningtarget/GetDepartmentsByTarget", row.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          row.departmentList = res.data;
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getAssignedDepartments(row) {
      row.assignedDepartments = [];
      this.$store
        .dispatch("planningtargetdepartment/GetPlanningTargetDepartment", row.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          row.assignedDepartments = res.data;
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getAllDepartments(id) {
      this.$store
        .dispatch("department/GetDepartmentByDU", id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          let data = [];
          res.data.map(item => {
            data.push({
              id: item.id,
              name: item.departmentName,
            });
          })
          this.allDepartments = data;
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getDepartmentsByTarget(row) {
      row.showDetails = !row.showDetails;
      this.$forceUpdate();
      if (row.showDetails) {
        await this.getDepartments(row);
        await this.getAssignedDepartments(row);
      }
    },
    filteredDetails(details) {
      let data = details;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.searchKey
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    async changeShowDepartment($event, row) {
      await this.$store
        .dispatch("planningtarget/ShowInDepartment", {
          id: row.id,
          showInDepartment: $event.srcElement.checked,
        })
        .then((res) => {
          if (res.data.error) {
            row.showInDepartment = !$event.srcElement.checked;
            return this.showToast(res.data.errorMessage, "error");
          }
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async saveAssignment(row) {
      let ids = [];
      row.departmentModels.map(item => {
        ids.push({
          planningTargetId: row.id,
          departmentId: item.id,
        })
      });
      await this.$store
        .dispatch("planningtargetdepartment/CreatePlanningTargetDepartment", ids)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.showToast("Successfully assigned!", "success");
          this.getAssignedDepartments(row);
          row.editAssDeps = false;
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    selectDeps(row) {
      row.editAssDeps = true;
      row.departmentModels = row.assignedDepartments.map(item => {
        return {
          id: item.departmentId,
          name: item.department,
          transId: item.id,
        }
      });
    },
    removeDepartment(event, row) {
      let data = cloneDeep(event);
      if (event.transId) {
        this.$store
          .dispatch("planningtargetdepartment/RemovePlanningTargetDepartment", event.transId)
          .then((res) => {
            if (res.data.error) {
              row.departmentModels.push(data);
              return this.showToast(res.data.errorMessage, "error");
            }
            let index = row.assignedDepartments.findIndex(x => x.id == event.transId);
            row.assignedDepartments.splice(index, 1);
          })
          .catch((err) => {
            row.departmentModels.push(data);
            this.showToast("Something went wrong!", "error");
          });
      }
    }
  },
};
</script>
<template>
  <Layout @changeCycle="changeCycle" @changeDU="changeDU">
    <PageHeader :title="title" :items="items" />
    <b-modal id="update-target-modal" :title="modalTitle" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop no-close-on-esc>
      <form v-if="selectedTargetData" @submit.prevent="onAddTarget" class="needs-validation" ref="targetForm">
        <div>
          <label for="">Target Description</label>
          <textarea class="form-control" placeholder="Type Target Description Here..." rows="5" v-model="pp.description"
            :class="{
              'is-invalid': submitted && $v.pp.description.$error,
            }"></textarea>
        </div>
        <div class="my-3">
          <label for="">Quarterly Target</label>
          <div v-if="selectedTargetData.planningMainTarget.indicatorItem.allowText">
            <div class="mb-3" v-for="x in 4" :key="x">
              <small>{{ `Quarter ${x}` }}</small>
              <textarea rows="2" v-model="pp[`q${x}Text`]" class="form-control" :placeholder="`Enter Quarter ${x}`"
                :class="{ 'is-invalid': submitted && !pp[`q${x}Text`] }"></textarea>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-md-3" v-for="x in 4" :key="x">
              <div class="d-flex align-items-center">
                <masked-input type="text" class="form-control w-100 text-center" :placeholder="`Quarter ${x}`"
                  v-model="pp[`q${x}`]" :mask="currencyMask" @input="calculateAnnualTarget" :class="{
                    'is-invalid': submitted && !pp[`q${x}`],
                  }"></masked-input>
                <b v-if="selectedTargetData.planningMainTarget.isPercentage" class="ms-2">%</b>
              </div>
              <div class="text-center">
                <small>Quarter {{ x }}</small>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 mb-3">
          <label for="">Annual Target</label>
          <div class="d-flex align-items-center" v-if="selectedTargetData.planningMainTarget.indicatorItem.allowText">
            <textarea rows="2" class="form-control" placeholder="Enter Annual Target" v-model="pp.cascadedTargetText"
              :class="{
                'is-invalid': submitted && !pp.cascadedTargetText,
              }"></textarea>
          </div>
          <div class="d-flex align-items-center" v-else>
            <masked-input type="text" class="form-control w-100" placeholder="Annual Target" v-model="pp.cascadedTarget"
              :mask="currencyMask" :class="{
                'is-invalid': submitted && !pp.cascadedTarget,
              }"></masked-input>
            <b v-if="selectedTargetData.planningMainTarget.isPercentage" class="ms-2">%</b>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Save changes</button>
          <button type="button" class="btn btn-link" @click="$bvModal.hide('update-target-modal')">
            Close
          </button>
        </div>
      </form>
    </b-modal>
    <div class="p-5 d-flex align-items-center justify-content-center" v-if="tableBusy">
      <div class="preloader-component me-2">
        <div class="status">
          <div class="spinner-chase w-25px h-25px">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
          </div>
        </div>
      </div>
      <h5 class="mb-0">Loading...</h5>
    </div>
    <div v-else-if="tableData.length == 0" class="p-5 text-center">
      <h5>No data available</h5>
    </div>
    <div v-else class="position-relative">
      <div class="text-right position-absolute" style="right: 0">
        <button type="button" class="btn btn-purple" @click="printTPMS">
          <i class="bx bx-printer me-1"></i> Print TPMS
        </button>
      </div>
      <b-tabs content-class="pt-3 pb-3 text-muted" v-model="tabIndex" nav-class="nav-tabs-custom">
        <div v-for="(type, index) in tabOptions" :key="index">
          <b-tab v-if="checkTab(type)" @click="
            filter = '';
          tabSelect = type;
          perPage = 10;
          currentPage = 1;
          ">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="mdi mdi-clock-time-four-outline"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ type }}</span>
            </template>
            <div>
              <div class="row">
                <div class="col-12">
                  <div class="card border-4 border-top border-start-0 border-end-0 border-primary table-responsive"
                    style="min-width: 1070px">
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <h4 class="card-title m-0">KPI List</h4>
                      </div>
                      <div class="row mt-4">
                        <div class="col-sm-12 col-md-6">
                          <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                              Show&nbsp;
                              <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                                :options="pageOptions"></b-form-select>&nbsp;entries
                            </label>
                          </div>
                        </div>
                        <!-- Search -->
                        <div class="col-sm-12 col-md-6">
                          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                            <label class="d-inline-flex align-items-center">
                              Search:
                              <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search..."
                                class="form-control form-control-sm ms-2"></b-form-input>
                            </label>
                          </div>
                        </div>
                        <!-- End search -->
                      </div>
                      <div v-if="paginatedData.length == 0" class="text-center">
                        <h5 v-if="filter">Search not found</h5>
                        <h5 v-else>No data available</h5>
                      </div>
                      <div role="tablist" v-for="(x, xIndex) in paginatedData" :key="x.indicatorItemId">
                        <b-card no-body class="mb-2 shadow-none" :style="{ 'z-index': paginatedData.length - xIndex }">
                          <b-card-header header-tag="header" role="tab" header-class="cursor-pointer border">
                            <div class="d-flex justify-content-between align-items-center" @click="getTagsByTarget(x)">
                              <div class="me-3">
                                <div>
                                  <b class="text-white">
                                    <a class="text-dark" href="javascript: void(0);">{{ x.indicatorItemName }}</a>
                                  </b>
                                </div>
                                <small>
                                  Targets Available ({{ x.details.length }})
                                </small>
                              </div>
                              <div class="d-flex align-items-center">
                                <div>
                                  <span class="d-flex align-items-center"><small v-if="!x.showTargets">Click here to
                                      expand</small>
                                    <div class="d-flex align-items-center">
                                      <i class="bx bx-chevron-right rotate font-size-18 ms-3" :class="{
                                        'rotate-90': x.showTargets,
                                      }"></i>
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </b-card-header>
                          <b-collapse :visible="x.showTargets" :accordion="`kpi-accordion-${type}-${x.indicatorItemId}`"
                            role="tabpanel">
                            <b-card-body v-if="x.showTargets" class="ps-5 pe-0 pt-3">
                              <div class="p-3 d-flex align-items-center" v-if="x.targetLoading">
                                <div class="preloader-component me-2">
                                  <div class="status">
                                    <div class="spinner-chase w-20px h-20px">
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                    </div>
                                  </div>
                                </div>
                                <h5 class="mb-0">Loading...</h5>
                              </div>
                              <div v-else>
                                <div class="d-flex align-items-center">
                                  <h6 class="card-title text-muted">
                                    {{ titleList }}
                                    List
                                  </h6>
                                </div>
                                <div role="tablist" v-for="(y, yIndex) in filteredDetails(
                                  x.details
                                )" :key="y.id">
                                  <b-card no-body class="mb-2 shadow-none position-relative" :style="{
                                    'z-index':
                                      filteredDetails(x.details).length -
                                      yIndex,
                                  }">
                                    <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" />
                                    <b-card-header header-tag="header" role="tab" header-class="cursor-pointer border">
                                      <div class="d-flex justify-content-between align-items-center">
                                        <div class="d-flex align-items-center">
                                          <div class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                            style="min-width: 30px">
                                            <h3 class="mb-0 position-relative">
                                              {{ yIndex + 1 }}
                                            </h3>
                                          </div>
                                          <div>
                                            <h6 class="mb-1">
                                              <a class="text-dark hoverable-link" href="javascript: void(0);" @click="
                                                getDepartmentsByTarget(y)
                                                ">{{ y.description }}</a>
                                            </h6>
                                            <template v-if="
                                              y.planningMainTarget
                                                .indicatorItem
                                                .allowDeliveryUnitToAddTag
                                            ">
                                              <b class="me-1">Tags: </b>
                                              <div class="d-inline">
                                                <span class="badge bg-success me-1 font-size-14" v-for="z in y.tags"
                                                  :key="z.id" :title="z.tag">
                                                  {{ z.tag
                                                  }}<span class="ms-3 cursor-pointer" @click="deleteTag(z, y)"><i
                                                      class="bx bx-x-circle text-danger"></i></span>
                                                </span>
                                                <span class="badge bg-secondary p-1 cursor-pointer" @click="addTags(y)">
                                                  <i class="bx bxs-purchase-tag-alt"></i>
                                                  Add
                                                  <span v-if="y.tags.length > 0">More</span>
                                                  Tags
                                                </span>
                                              </div>
                                            </template>
                                          </div>
                                        </div>
                                        <div class="d-flex align-items-center">
                                          <div>
                                            <i class="bx bx-chevron-right rotate font-size-18 ms-3" :class="{
                                              'rotate-90': y.showDetails,
                                            }" @click="getDepartmentsByTarget(y)"></i>
                                          </div>
                                        </div>
                                      </div>
                                    </b-card-header>
                                    <b-collapse :visible="y.showDetails" :accordion="`target-accordion-${type}-${y.id}`"
                                      role="tabpanel">
                                      <b-card-body v-if="y.showDetails" class="border px-2 py-2">
                                        <div class="px-5">
                                          <div class="d-flex gap-5 mt-3">
                                            <div class="col-md-4">
                                              <div class="mb-2">
                                                <div class="d-flex gap-2">
                                                  <label class="text-white">Assigned Departments:</label>
                                                </div>
                                                <div class="d-flex" v-if="!y.editAssDeps">
                                                  <div class="form-control">
                                                    <span v-if="
                                                      y.assignedDepartments.length ==
                                                      0
                                                    " class="text-warning">N/A</span>
                                                    <span class="badge bg-purple me-1 font-size-14 my-1"
                                                      v-for="department in y.assignedDepartments"
                                                      :key="department.id"><b class="font-size-11">{{
                                                        department.department
                                                      }}</b></span>
                                                  </div>
                                                  <button type="button" class="btn btn-outline-info h-100"
                                                    title="Edit Assigned Departments" @click="selectDeps(y)"><i
                                                      class="bx bx-edit"></i></button>
                                                </div>
                                                <div class="d-flex" v-else>
                                                  <multiselect v-model="y.departmentModels"
                                                    placeholder="Select departments" track-by="id" label="name"
                                                    :options="allDepartments" :searchable="true" :multiple="true"
                                                    :close-on-select="false" @remove="removeDepartment($event, y)">
                                                  </multiselect>
                                                  <button type="button" class="btn btn-outline-success h-100"
                                                    title="Save" @click="saveAssignment(y)"><i
                                                      class="bx bx-check"></i></button>
                                                  <button type="button" class="btn btn-outline-secondary h-100"
                                                    title="Cancel" @click="y.editAssDeps = false"><i
                                                      class="bx bx-x"></i></button>
                                                </div>
                                              </div>
                                              <div class="mb-2">
                                                <div class="d-flex gap-2">
                                                  <label class="text-white">Departments:</label>
                                                  <!-- <div
                                                    class="
                                                      form-check
                                                      form-checkbox-outline
                                                      form-check-success
                                                      mb-0
                                                      ms-2
                                                    "
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      class="form-check-input"
                                                      v-model="y.showInDepartment"
                                                      :id="`customCheckcolor${y.id}`"
                                                      @click="changeShowDepartment($event, y)"
                                                    />
                                                    <label
                                                      :for="`customCheckcolor${y.id}`"
                                                      class="form-check-label"
                                                    >
                                                      <span>Show to Department</span>
                                                    </label>
                                                  </div> -->
                                                </div>
                                                <div class="form-control">
                                                  <span v-if="
                                                    y.departmentList.length ==
                                                    0
                                                  " class="text-warning">N/A</span>
                                                  <span
                                                    class="badge bg-purple me-1 font-size-14 d-flex align-items-center"
                                                    style="
                                                      max-width: min-content;
                                                    " v-for="department in y.departmentList" :key="department.id"><b
                                                      class="font-size-11">{{
                                                        department.departmentName
                                                      }}</b></span>
                                                </div>
                                              </div>
                                              <div class="mb-2">
                                                <label class="text-white">Cycle:</label>
                                                <div class="form-control text-warning">
                                                  {{
                                                    y.planningMainTarget.cycle
                                                      ? y.planningMainTarget
                                                        .cycle
                                                      : "N/A"
                                                  }}
                                                </div>
                                              </div>
                                              <!-- <div class="mb-2">
                                                <label class="text-white"
                                                  >Item Name:</label
                                                >
                                                <div
                                                  class="form-control text-warning"
                                                >
                                                  {{
                                                    y.planningMainTarget
                                                      .indicatorItem
                                                      .indicatorItemName
                                                      ? y.planningMainTarget
                                                          .indicatorItem
                                                          .indicatorItemName
                                                      : "N/A"
                                                  }}
                                                </div>
                                              </div> -->
                                              <div class="mb-2">
                                                <label class="text-white">Type:</label>
                                                <div class="form-control text-warning">
                                                  {{
                                                    y.planningMainTarget
                                                      .indicatorItem.type
                                                      ? y.planningMainTarget
                                                        .indicatorItem.type
                                                      : "N/A"
                                                  }}
                                                </div>
                                              </div>
                                              <div class="mb-2">
                                                <label class="text-white">Annual Target:</label>
                                                <div class="form-control text-warning">
                                                  {{
                                                    y.planningMainTarget
                                                      .isPercentage
                                                      ? y.cascadedTarget + "%"
                                                      : y.cascadedTarget
                                                  }}
                                                </div>
                                              </div>
                                              <div class="mb-4">
                                                <label class="text-white">Other Info:</label>
                                                <div class="d-flex align-items-center mb-1">
                                                  <span class="d-flex align-items-center border p-1 me-2">
                                                    <i class="bx font-size-18 font-weight-bolder bx-x text-danger" v-if="
                                                      !y.planningMainTarget
                                                        .isPercentage
                                                    "></i>
                                                    <i class="bx font-size-18 font-weight-bolder bx-check text-success"
                                                      v-if="
                                                        y.planningMainTarget
                                                          .isPercentage
                                                      "></i>
                                                    <div>Percentage</div>
                                                  </span><span class="d-flex align-items-center border p-1 me-2">
                                                    <i class="bx font-size-18 font-weight-bolder bx-x text-danger" v-if="
                                                      !y.planningMainTarget
                                                        .indicatorItem
                                                        .isCompleted
                                                    "></i>
                                                    <i class="bx font-size-18 font-weight-bolder bx-check text-success"
                                                      v-if="
                                                        y.planningMainTarget
                                                          .indicatorItem
                                                          .isCompleted
                                                      "></i>
                                                    <div>Completed</div>
                                                  </span><span class="d-flex align-items-center border p-1 me-1">
                                                    <i class="bx font-size-18 font-weight-bolder bx-x text-danger" v-if="
                                                      !y.planningMainTarget
                                                        .indicatorItem
                                                        .isRecurring
                                                    "></i>
                                                    <i class="bx font-size-18 font-weight-bolder bx-check text-success"
                                                      v-if="
                                                        y.planningMainTarget
                                                          .indicatorItem
                                                          .isRecurring
                                                      "></i>
                                                    <div>Recurring</div>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div style="width: 100%">
                                              <div class="table-responsive">
                                                <div class="text-right mb-2" style="min-width: max-content">
                                                  <button type="button" @click="setMeasurement(y)"
                                                    class="btn btn-sm btn-primary ms-2">
                                                    <i class="bx bxs-star text-warning fs-6"></i>
                                                    Set Performance Rubric
                                                  </button>
                                                  <button type="button" @click="updateTarget(y)"
                                                    class="btn btn-sm btn-success ms-2" v-if="
                                                      y.allowEdit &&
                                                      !isOPCRPosted
                                                    ">
                                                    <i class="bx bx-edit fs-6"></i>
                                                    Update Target
                                                  </button>
                                                  <button type="button" @click="addTarget(y)"
                                                    class="btn btn-sm btn-info ms-2" v-if="
                                                      y.planningMainTarget
                                                        .allowAdd &&
                                                      !isOPCRPosted
                                                    ">
                                                    <i class="bx bx-plus fs-6"></i>
                                                    Add Target
                                                  </button>
                                                  <button type="button" @click="deletePPTarget(y)"
                                                    class="btn btn-sm btn-danger ms-2" v-if="
                                                      y.allowEdit &&
                                                      !isOPCRPosted
                                                    ">
                                                    <i class="bx bx-trash fs-6"></i>
                                                    Delete Target
                                                  </button>
                                                </div>
                                                <table class="table table-bordered border-primary mb-0">
                                                  <tbody>
                                                    <template v-for="n in 4">
                                                      <tr :key="n">
                                                        <td class="text-center text-white" style="width:300px;">Quarter
                                                          {{ n }}</td>
                                                        <td class="text-center">
                                                          <template v-if="y.planningMainTarget.indicatorItem.allowText">
                                                            {{ y[`q${n}Text`] }}
                                                          </template>
                                                          <template v-else>
                                                            {{
                                                              y.planningMainTarget
                                                                .isPercentage
                                                                ? y[`q${n}`] + "%"
                                                                : y[`q${n}`]
                                                            }}
                                                          </template>
                                                        </td>
                                                      </tr>
                                                    </template>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </b-card-body>
                                    </b-collapse>
                                  </b-card>
                                </div>
                              </div>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                      </div>
                      <div class="row">
                        <div class="col">
                          <div class="dataTables_paginate paging_simple_numbers float-end">
                            <ul class="pagination pagination-rounded mb-0">
                              <!-- pagination -->
                              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </div>
      </b-tabs>
    </div>
    <PlanningRatingScale ref="PlanningRatingScale"></PlanningRatingScale>
    <print-options ref="printOpt"></print-options>
    <kpi-tags ref="kpiTags" @drop-data="dropKpiTags"></kpi-tags>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}
</style>